import '../stylesheets/co_scientist_landing.scss';
import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
import registerForRails from 'js/utils/registerForRails';
import CoScientistLandingNavbar from 'js/co_scientist_landing/CoScientistLandingNavbar';
import CoScientistLandingPage from 'js/co_scientist_landing/CoScientistLandingPage';
import CoScientistPricingPage from 'js/co_scientist_landing/CoScientistPricingPage';

setUpModernPage();

registerForRails({
  CoScientistLandingNavbar,
  CoScientistLandingPage,
  CoScientistPricingPage,
});
